import { Card, Typography, Space, Row, Col, Statistic } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";

const { Text } = Typography;

export const WhatsAppStatsSection: React.FC = () => {
  return (
    <Card className="rounded-2xl border-gray-100 shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <Space size="middle">
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-green-50 text-green-500">
            <WhatsAppOutlined className="text-lg" />
          </div>
          <div>
            <Text strong className="text-gray-800 text-base block">
              WhatsApp Notification & Alerts
            </Text>
            <Text type="secondary" className="text-xs">
              WhatsApp API session volume & system delivery rate
            </Text>
          </div>
        </Space>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-green-50/40 border-green-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Total Messages
                </Text>
              }
              value={15230}
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#10b981" }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-blue-50/40 border-blue-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Session Chats
                </Text>
              }
              value={48}
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#3b82f6" }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-purple-50/40 border-purple-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Template Messages
                </Text>
              }
              value={12}
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#8b5cf6" }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-orange-50/40 border-orange-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Delivery Rate
                </Text>
              }
              value={99.4}
              suffix="%"
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#f97316" }}
            />
          </Card>
        </Col>
      </Row>

      <div className="relative h-44 flex items-end gap-1 px-2 pt-6 bg-gray-50/30 border border-gray-100 rounded-xl">
        {Array.from({ length: 31 }, (_, i) => {
          const day = i + 1;
          const height = Math.max(6, Math.floor(Math.random() * 90));
          const color =
            height > 70
              ? "bg-emerald-400"
              : height > 40
                ? "bg-blue-400"
                : "bg-gray-300";
          return (
            <div
              key={day}
              className="flex-1 flex flex-col items-center gap-0.5 group relative"
            >
              <div className="absolute -top-7 text-[10px] bg-gray-900 text-white rounded px-1.5 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-200 font-mono pointer-events-none z-10">
                {height}
              </div>
              <div
                className={`w-full rounded-t ${color} transition-all hover:opacity-80 cursor-pointer`}
                style={{ height: `${height}%` }}
              />
              {day % 5 === 1 && (
                <span className="text-[9px] text-gray-400 mt-1 font-mono">
                  {day}
                </span>
              )}
            </div>
          );
        })}
      </div>
      <div className="flex justify-between mt-2 px-2">
        <span className="text-[10px] text-gray-400 font-medium">Day 1</span>
        <span className="text-[10px] text-gray-400 font-medium">Day 31</span>
      </div>
    </Card>
  );
};
